var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 24,
    height: 2,
    fill: "#042B41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 24,
    height: 2,
    fill: "#042B41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 18,
    width: 24,
    height: 2,
    fill: "#042B41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.ec79e65027762ce04901620694830546.svg";
export { ForwardRef as ReactComponent };